<div class="upload-btn-wrapper">
  <po-button
    p-kind="primary"
    (click)="openFileUpload()"
    [p-icon]="icon"
    [p-label]="label | translate"
    [p-loading]="isLoading"
    data-cy="btn-continue"
  >
  </po-button>
  <input
    #fileUpload
    type="file"
    id="buttonUpload"
    class="button-upload-resume"
    aria-label="btnUpload"
    (change)="onFileSelected($event)"
    accept=".pdf"
  />
</div>
